import { createContext } from 'react'
import { getPlatformGlobal, setPlatformGlobals } from '../../index'
import type { ViewStateContextData } from './types'

/**
 * ViewStateContext and ViewStateScope allow us to categorise components under
 * a given scope.
 */
export const ViewStateContext =
  getPlatformGlobal('ViewStateContext') ??
  createContext<ViewStateContextData | undefined>(undefined)

setPlatformGlobals({ ViewStateContext })
